/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CompoundingReasonModel = {
    Allergy: 'ALLERGY',
    AllergyOrIntoleranceSuspected: 'ALLERGY_OR_INTOLERANCE_SUSPECTED',
    ApprovedProductShortage: 'APPROVED_PRODUCT_SHORTAGE',
    DosageForm: 'DOSAGE_FORM',
    Flavor: 'FLAVOR',
    NoApprovedProduct: 'NO_APPROVED_PRODUCT',
    Strength: 'STRENGTH',
    Swallow: 'SWALLOW',
    Other: 'OTHER'
} as const;
export type CompoundingReasonModel = typeof CompoundingReasonModel[keyof typeof CompoundingReasonModel];


export function CompoundingReasonModelFromJSON(json: any): CompoundingReasonModel {
    return CompoundingReasonModelFromJSONTyped(json, false);
}

export function CompoundingReasonModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompoundingReasonModel {
    return json as CompoundingReasonModel;
}

export function CompoundingReasonModelToJSON(value?: CompoundingReasonModel | null): any {
    return value as any;
}

